import script from "./ContactInquiryType.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactInquiryType.vue?vue&type=script&setup=true&lang=ts"

import "./ContactInquiryType.vue?vue&type=style&index=0&id=ca44aade&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca44aade"]])

export default __exports__